import { SendToSalesDataType } from 'b2b-common/core/account/api/wishlists';
import { CLEAR_WISHLIST_SEND, WISHLIST_SEND, WISHLIST_SEND_FULFILLED, WISHLIST_SEND_REJECTED } from './actionTypes';
import {
  ClearWishlistSendAction,
  WishlistSendAction,
  WishlistSendFulfilledAction,
  WishlistSendRejectedAction,
} from './types';


const clearWishlistSend = (): ClearWishlistSendAction => ({
  type: CLEAR_WISHLIST_SEND,
});

const wishlistSend = (wishlistId: string, data: SendToSalesDataType): WishlistSendAction => ({
  type: WISHLIST_SEND,
  payload: {
    wishlistId,
    data,
  },
});

const wishlistSendFulfilled = (): WishlistSendFulfilledAction => ({
  type: WISHLIST_SEND_FULFILLED,
});

const wishlistSendRejected = (error: ErrorType): WishlistSendRejectedAction => ({
  type: WISHLIST_SEND_REJECTED,
  payload: {
    error,
  },
});

export {
  clearWishlistSend,
  wishlistSend,
  wishlistSendFulfilled,
  wishlistSendRejected,
};
